<div class="container">
  <div class="flex-start mt-4">
    <button type="button" class="btn btn-default add-button" (click)="openEditModal(null)">
    <i class="fas fa-plus"></i> Add new
  </button>
  </div>
  <div class="user-list mb-3 table-responsive" *ngIf="subscriptions && subscriptions.length > 0">
    <table class="table table-responsive-lg">
      <thead>
      <tr>
        <th class="text-center" scope="col">#</th>
        <th class="text-center" scope="col">Price</th>
        <th class="text-center" scope="col">Type</th>
        <th class="text-center" scope="col">Lessons count</th>
        <th class="text-center" scope="col">Name</th>
        <th class="text-center" scope="col">Description</th>
        <th class="text-center" scope="col">Payment Link</th>
        <th class="text-center" scope="col">Is Online</th>
        <th></th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let subscription of subscriptions">
        <td class="text-center">{{ subscription.id }}</td>
        <td class="text-center">{{ subscription.price }}</td>
        <td class="text-center">{{ getSubscriptionType(subscription) }}</td>
        <td class="text-center">{{ subscription.lessonsCount }}</td>
        <td class="text-center">{{ subscription.nameHebrew }}</td>
        <td class="text-center">{{ subscription.descriptionHebrew }}</td>
        <td class="text-center">
          <ng-container *ngIf="subscription?.stripePaymentLink">
            <a href="{{subscription.stripePaymentLink}}">{{ subscription.stripePaymentLink }}</a>
          </ng-container>

          <ng-container *ngIf="subscription?.camp">
            <ng-container *ngFor="let price of subscription.camp.prices">
              <div *ngIf="price.stripePaymentLink">
                {{price.periodCount}} period(s): <a href="{{price.stripePaymentLink}}">{{ price.stripePaymentLink }}</a><br>
              </div>
            </ng-container>
            <a href="{{subscription.stripePaymentLink}}">{{ subscription.stripePaymentLink }}</a>
          </ng-container>

        </td>
        <td class="text-center">{{ subscription.isOnline ? 'Yes' : 'No' }}</td>
        <td class="text-center">
          <button type="button" class="btn btn-light edit-button" (click)="openEditModal(subscription)">
            <i class="fas fa-pencil"></i>
          </button>
        </td>
        <td>
          <button type="button" class="btn btn-danger delete-button" (click)="openDeleteConfirmModal(subscription)">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="errorMessage" class="alert alert-danger">
    {{ errorMessage }}
  </div>
</div>
